import React from 'react';

import './ImgDisplayer.css';

class ImageDisplayer extends React.Component {

  drawBox(canvas, box, width, height) {
    const bb = {
      top: box.left * width,
      left: box.top * height,
      height: box.width * width,
      width: box.height * height
    };

    const context = canvas.getContext('2d');
    context.strokeStyle = '#ff0000';
    context.lineWidth = 3;

    const coords = [
      [bb.top, bb.left],
      [bb.top, bb.left + bb.width],
      [bb.top + bb.height, bb.left + bb.width],
      [bb.top + bb.height, bb.left]
    ];

    context.beginPath();
    context.moveTo(...coords[0]);
    context.lineTo(...coords[1]);
    context.lineTo(...coords[2]);
    context.lineTo(...coords[3]);
    context.closePath();
    context.stroke();
  }

  afterImageLoaded() {
    const width = this.imageRef.current.clientWidth;
    const height = this.imageRef.current.clientHeight;

    this.canvasRef.current.width = width;
    this.canvasRef.current.height = height;

    this.drawBox(this.canvasRef.current, this.props.box, width, height);
  }

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.imageRef = React.createRef();
  }

  render() {
    return (
      <div className="image-displayer">
        <img src={this.props.src} alt="img" className="img rounded-md" ref={this.imageRef} />
        {this.props.box && <canvas ref={this.canvasRef} className="canvas" />}
      </div>
    );
  }

  componentDidMount() {
    if (this.canvasRef.current && this.imageRef.current) {
      // console.log('entered')
      if (this.imageRef.current.width > 0 && this.imageRef.current.height > 0 ) {
        // console.log('nowimgload')
        this.afterImageLoaded();
      }
      else {
        // console.log('imgalready')
        this.imageRef.current.onload = this.afterImageLoaded.bind(this);
      }
    }
  }

  componentDidUpdate(){
    this.componentDidMount()
  }
}


export default ImageDisplayer;
